import { render, staticRenderFns } from "./PaintCanvas.vue?vue&type=template&id=b7217daa&scoped=true&"
import script from "./PaintCanvas.vue?vue&type=script&lang=js&"
export * from "./PaintCanvas.vue?vue&type=script&lang=js&"
import style0 from "./PaintCanvas.vue?vue&type=style&index=0&id=b7217daa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7217daa",
  null
  
)

export default component.exports